<template>
<div id="DeviceList" class="list-container">
    <div class="title-container">
        <div class="search-area">
            <div class="search-item">
                <div class="key">{{$t(/*在线状态*/'device.online_status')}}：</div>
                <div class="value">
                    <el-radio-group v-model="searchForm.status" @change="pageChange(1)">
                        <el-radio-button v-for='(item,index) of statusList' :key='index' :label="item.value" >{{$t(item.key)}}</el-radio-button>
                    </el-radio-group>
                </div>
            </div>
            <div class="search-item">
                <div class="key">{{$t(/*设备UID*/'device.device_uid')}}：</div>
                <div class="value">
                    <el-input v-model="searchForm.uid" :placeholder="$t(/*请输入*/'c.input')" @blur="pageChange(1)" @keydown.native.enter='pageChange(1)'/>
                </div>
            </div>
            <div class="search-item" v-if="$auth('ADMIN')">
                <div class="key">{{$t(/*用户*/'c.user')}}：</div>
                <div class="value">
                    <el-select v-model="searchForm.user_id" :placeholder="$t(/*请选择*/'c.select')" @change="pageChange(1)" clearable filterable>
                        <el-option v-for="item of userList" :label="item.username" :value="item.id" :key="item.id"/>
                    </el-select>
                </div>
            </div>
            <div class="search-btn">
                <el-button type="primary" @click="pageChange(1)">{{$t(/*搜索*/'c.search')}}</el-button>
            </div>
        </div>
        <div class="btn-area">
            <EditDevice :space="space" btnType='primary' :btnText="$t(/*新增*/'c.add')+$t(/*设备*/'device.device')" @change='getTableData' v-if="$auth('ADMIN')"/>
        </div>
    </div>

    <div class="table-container">
        <el-table :data="tableData" v-loading='loading'>
            <el-table-column min-width="200" :label="$t(/*设备UID*/'device.device_uid')" prop="uid">
                <template slot-scope="{row}">
                    <router-link target="_blank" class="router-link" :to="getRouterLink('detail', row)">
                        {{ row.uid }}
                    </router-link>
                </template>
            </el-table-column>
            <!-- <el-table-column width="160" :label="$t(/*用户*/'c.user')" prop="username" v-if="$auth('ADMIN')">
                <template slot-scope="{row, $index}">
                    <template v-if="row.user_ids && row.user_ids.length">
                        <el-button type="text" @click='getAllotUserList(row, $index)'>{{$t(/*已分配给?位用户*/'device.distributed', row.user_ids.length)}}</el-button>
                    </template>
                    <template v-else>{{$t(/*尚未分配*/'device.no_distribute')}}</template>
                </template>
            </el-table-column> -->
            <el-table-column width="180" :label="$t(/*在线状态*/'device.online_status')">
                <template slot-scope="{row}">
                    <div class="round-tag" :class="$U.deviceStatusFilter(row, 'class')">
                        {{$t($U.deviceStatusFilter(row))}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column width="180" :label="$t(/*最后活动时间*/'device.last_active_time')" prop="active_time">
                <template slot-scope="{row}">
                    {{$U.timeFormat(row.last_active_time)}}
                </template>
            </el-table-column>
            <el-table-column width="180" :label="$t(/*创建时间*/'c.create_time')" prop="create_time">
                <template slot-scope="{row}">
                    {{$U.timeFormat(row.create_time)}}
                </template>
            </el-table-column>
            <el-table-column width='210' :label="$t(/*操作*/'c.operation')" fixed="right" v-if="$auth('ADMIN')">
                <template slot-scope="{row}">
                    <AllotDevice :btnText="$t(/*分配*/'device.distribute')" :space="space" :detail='row' @change='getTableData'/>
                    <div class="divide"/>
                    <EditDevice :space="space" :detail='row' @change='getTableData'/>
                    <div class="divide"/>
					<el-button type="text danger" @click='handleClearCache(row.id)'>{{$t(/*清理缓存*/'device.clear_cache')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <div class="paging-container">
        <el-pagination @current-change="pageChange" :current-page="currPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"/>
    </div>
</div>
</template>

<script type="text/ecmascript-6">

import Core from '../../core'

export default {
    components: {
        EditDevice:  () => import('./components/EditDevice.vue'),
        AllotDevice: () => import('./components/AllotDevice.vue'),
    },
    data() {
        return {
            space: '', // 通过router获取

            loading: false,

            // 搜索
            searchForm: {
                uid: '',
                user_id: '',
                status: '',
            },
            userList: [],
            statusList: Core.Const.DEVICE.STATUS_LIST,

            // 表格数据
            tableData: [],

            // 分页配置
            currPage: 1,
            total: 0,
            pageSize: 20,
        }
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(newRoute) {
                console.log('newRoute:', newRoute)
                this.space = newRoute.meta.space
                this.pageChange(1);
            }
        }
    },
    mounted() {
        if (this.$auth('ADMIN')) {
            this.getAllUserList()
        }
    },
    methods: {
        getRouterLink(key, item = {}) {
            switch (key) {
                case 'detail':
                    return {
                        path: `/device/${this.space}/detail`,
                        query: {uid: item.uid}
                    }
            }
        },
        // 页码变更
        pageChange(val) {
            this.currPage = val;
            this.getTableData();
        },
        // 获取表格数据 - 设备列表
        async getTableData() {
            this.loading = true
            if (this.$auth('CLIENT')) {
                this.searchForm.user_id = Core.Data.getUser().id
            }
            let res = await Core.Api.Vehicle.list({
                space: this.space,
                page: this.currPage,
                ...this.searchForm
            });
            console.log("getTableData res", res)
            this.tableData = res.vehicle_list;
            console.log('getTableData tableData: ', res.vehicle_list);
            this.total = res.count;
            this.loading = false
        },
        // 获取用户列表
        async getAllUserList() {
            let res = await Core.Api.User.listAll();
            this.userList = res.user_list || [];
            console.log('getAllUserList list', this.userList)
        },

        async getAllotUserList(item, index) {
            console.log('getAllotUserList item:', item)
            if (!item.user_names || item.user_names.length !== item.user_ids.length) {
                try {
                    let {list} = await Core.Api.Device.allotUserList({device_id: item.device_id})
                    item.user_names = list || []
                } catch (error) {
                    item.user_names = []
                }
            }
            const h = this.$createElement;
            this.$msgbox({
                title: this.$t(/*用户*/'c.user'),
                showCancelButton: false,
                confirmButtonText: this.$t(/*确定*/'c.confirm'),
                message: h('div', { class: 'allot-user-list-msgbox' }, item.user_names.map(item => {
                    return h('div', { class: 'allot-item' }, [
                        h('div', { class: 'username' }, this.$t(/*用户名*/'user.username')+'：'+item.username),
                        h('div', { class: 'expire_time' }, this.$t(/*过期时间*/'device.expire_time')+'：'+(item.expire_time ? Core.Filter.timeFormat(item.expire_time) : '-')),
                    ])
                })),
            });
        },

        handleClearCache(uid) {
			this.$confirm(this.$t(/*确定清除该设备的路由缓存吗？*/'device.clear_cache_ask'), this.$t(/*提示*/'c.tip'), {
                confirmButtonText: this.$t(/*确定*/'c.confirm'),
				cancelButtonText: this.$t(/*取消*/'c.cancel'),
				type: 'warning'
			}).then(() => {
				Core.Api.Cache.clear({space: this.space, uid}).then(() => {
                    this.$message.success(this.$t(/*操作成功*/'c.oper_success'))
                }).catch(err => {
                    console.log('handleDialogConfirm err:', err)
                }).finally(() => {
					this.getTableData()
                })
			})
		},
    }
}
</script>

<style scoped lang="scss">
// #DeviceList {}
.allot-user-list-msgbox {
    width: 100%;
    display: flex;
    flex-direction: column;
    .allot-item {
        width: 100%;
        + .allot-item {
            margin-top: 15px;
        }
        .username {

        }
    }
}
</style>
